import React from 'react';
import { APPS } from '../../apps.config';
import AppCard from './AppCard';

export default function Dashboard() {
  return (
    <div className="dashboard-list">
      {APPS.map(app => (
        <AppCard key={app.id} app={app} />
      ))}
    </div>
  );
}
